<!-- <div class="w3-col m8 w3-container w3-margin-bottom info-container2 w3-center w3-hover-shadow w3-borderB"> -->
  <ul class="w3-ul w3-margin-top" style="font-size:12px;">
    <h5 style="color:rgb(22, 21, 21); background:darkseagreen;" class="px-3 pt-1"><b>ONGOING PROJECTS</b></h5>

    <p style="font-size:11px; margin-left:15px; margin-right:10px; color:black; text-align: justify;"><b>Three
        projects namely WJC-VI, JLN-II & BCC-II were approved under
        CADWM Programme,
        wherein WJC Canal Command Ph-VI and JLN Canal Command Ph–II projects were included during the financial year
        2007-08 under CADWM programme by GOI,
        MOWR vide sanction letter NO.13-6/2006-CADWM dated 06.02.2008 and Bhakra Canal Command Phase-II Project was
        included under CADWM Programme by Government
        of India MOWR vide sanction letter dated 25.05.2009 during the financial year 2009-10. Now, due to
        discontinuation of CADWM Programme by Government of India in the year 2016, these projects are being executed
        from state funds since 2016-17.</b></p>
    <h5 style="color:rgb(22, 21, 21); background:darkseagreen;" class="px-3"><b>BRIEF DETAIL OF ONGOING PROJECTS BEING
        EXECUTED IS AS UNDER</b></h5>
    <b style="margin-left:12px;">1. WESTERN JAMUNA CANAL COMMAND PH-VI PROJECT</b>
    <p style="font-size:11px; margin-left:15px; margin-right:10px; color:black; text-align: justify;"><b>As per DPR,
        under this Project an area of 2,05,600 ha. CCA will be
        covered by constructing 1542 watercourses with an estimated
        cost of Rs. 459.92 crore. The farmers of Rohtak, Jhajjar, Sonepat, Jind, Bhiwani, Gurugram, Panipat & Karnal
        districts are being
        benefited under this project. 173514 ha. CCA has been covered by constructing 1044 watercourses under this
        project.</b></p>

    <b style="margin-left:12px;">2. JLN CANAL COMMAND PHASE II PROJECT</b>
    <p style="font-size:11px; margin-left:15px; margin-right:10px; color:black; text-align: justify;"><b>As per DPR,
        under this Project 99,383 ha. CCA was to be covered by
        constructing 525 watercourses.
        But, MoU for covering 74537 ha. CCA was signed with a revised estimated cost of Rs. 205.07 crore. The farmers
        of Jhajjar, Rewari, Gurugram, Mahendragarh
        & Bhiwani districts are being benefited under this project. 13488 ha. CCA has been covered by constructing 119
        watercourses under this project.</b></p>
    <b style="margin-left:12px;">3. BHAKRA CANAL COMMAND PHASE-II PROJECT</b>
    <p style="font-size:11px; margin-left:15px; margin-right:10px; color:black; text-align: justify;"><b>As per DPR,
        under this Project 351853 ha. CCA will be covered by
        constructing 1982 watercourses with an
        estimated cost of Rs. 815.18 crore. The farmers of Hisar, Sirsa, Fatehabad, Ambala, Kurukshetra, Kaithal,
        Karnal & Jind districts are being benefited
        under this project. 304225 ha. CCA has been covered by constructing 1648 watercourses under this project.</b>
    </p><br>
  </ul>
<!-- </div> -->